import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=38d5254f&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=38d5254f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5254f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38d5254f')) {
      api.createRecord('38d5254f', component.options)
    } else {
      api.reload('38d5254f', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=38d5254f&scoped=true&", function () {
      api.rerender('38d5254f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bz3z9Xm55MeJ/JS/comp/PopupBox.vue"
export default component.exports